<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8812 11.9961L4.64405 18.2343C4.33479 18.5435 4.33479 19.0449 4.64405 19.3542C4.95331 19.6634 5.45473 19.6634 5.76399 19.3542L12.0012 13.117L18.2394 19.3542C18.5486 19.6634 19.05 19.6634 19.3593 19.3542C19.6686 19.0449 19.6686 18.5435 19.3593 18.2343L13.1221 11.9961L19.3593 5.75886C19.6686 5.4496 19.6686 4.94818 19.3593 4.63893C19.05 4.32967 18.5486 4.32967 18.2394 4.63893L12.0012 10.8761L5.76399 4.63893C5.45473 4.32967 4.95331 4.32967 4.64405 4.63893C4.33479 4.94818 4.33479 5.4496 4.64405 5.75886L10.8812 11.9961Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Cross'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
